import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../../misc/constants";
import { globals } from "../../../../../misc/globals";
import BasePracticeScenario from "../../../../base-practice-scenario/BasePracticeScenario";
import { DaarcBaseScenario } from "../../../../DaarcBaseScenario";
import { GeneralProceduresCricPart8Config, GeneralProceduresCricMainConfig } from "../GeneralProceduresCricMain";

export default class GeneralProceduresCricPart8 extends BaseScenarioPart<DaarcBaseScenario> {
	private get config(): GeneralProceduresCricPart8Config {
		return this.scenarioConfig.part8Config;
	}
	constructor(private _scenario: DaarcBaseScenario, private onDone: () => void, private id: string, private scenarioConfig: GeneralProceduresCricMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		const context = this;
		context.scenario.addScore(context.scenario.cricEtTubeCuffPoints);
		var onDoneWithPopup = context._scenario.doSomething('Inflating ET Tube Cuff...');

		setTimeout(() => {
			onDoneWithPopup();
			//context.scenario.addScore(context.scenario.cricAmbuBagSqueeze);
			if(context.scenarioConfig.isAttemptSuccessful()) {
				(context.scenario as BasePracticeScenario).stopApneaTimerForEntireRunThrough();
			}
			context.playVideoChapter(context.config.squeezeAmbuBagVideoChapter(), () => {
				context.step2PlayFeedback();
			});
		}, constants.doSomethingTimeout);
	}

	public step2PlayFeedback() {
		const context = this;
		context._scenario.uiWrapper.displayNotificationUI({
			text: `<p class='notification-text'>Squeezing Ambubag</p>`,
			onDismissed: () => {
				context.step4MovingAir();
			}
		})

		if(context.scenarioConfig.isAttemptSuccessful()) {
			(context.scenario as BasePracticeScenario).stopApneaTimerForEntireRunThrough();
		}

	}

	public step4MovingAir() {
		const context = this;
		const isSuccessful = this.scenarioConfig.isAttemptSuccessful();

		if(isSuccessful) {
			context._scenario.uiWrapper.displayNotificationUI({
				text: `<p class='notification-text'>${ 'Moving Air'}</p>`,
				onDismissed: () => {
				}
			})
			context.scenario.gameManager.SoundManager.playSound({
				src: './assets/audio/bvm/BVMmovingair.mp3',
				autoPlay: true,
				enableClosedCaptioning: false,
				muted: globals.isMuted,
				volume: 1
			});
		}
		
		context.onDone();
		// context.playVideoChapter(context._videoChapters.step4RTMovingAir, () => {
		// 	context.onDone();
		// })
	}
}